export var ThemeOptions;
(function(ThemeOptions) {
    ThemeOptions["DARK"] = "dark";
    ThemeOptions["LIGHT"] = "light";
})(ThemeOptions || (ThemeOptions = {}));
export var ThemeSkin;
(function(ThemeSkin) {
    ThemeSkin["NONE"] = "none";
    ThemeSkin["GREEN"] = "light-green";
    // for CTE (Complete Theme Experience) project
    ThemeSkin["PRIMARY"] = "skin-primary";
    ThemeSkin["SECONDARY"] = "skin-secondary";
    ThemeSkin["TERTIARY"] = "skin-tertiary";
})(ThemeSkin || (ThemeSkin = {}));
